import OtherTabController from './otherTabController';
import LearningAreaService from "../../../../services/learningAreaService";

const OtherTabComponent = {
    template: require('./otherTabView.html'),
    controller: OtherTabController,
};

OtherTabController.$inject = [
    'EvaluationService',
    'StepLearningGoalsService',
    'LearningAreaService',
    'UserService',
    '$stateParams',
    '$state',
    '$mdDialog',
    '$mdToast',
];

export default OtherTabComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/pages/otherTab/otherTabComponent.js